// extracted by mini-css-extract-plugin
export default {"rounded-card":"RoundedCard_rounded-card__IX7iE"};